<span class="c-placeholder-skeleton">
	{{#if type === "header"}}
		<span class="skeleton-header">
			<span class="skeleton_animated"></span>
		</span>
	{{elseif type === "subheader"}}
		<span class="skeleton-subheader">
			<span class="skeleton-subheader_content-wrapper">
				<span class="skeleton_animated"></span>
			</span>
		</span>
	{{elseif type === "descr"}}
		<span class="skeleton-descr">
			<span class="skeleton_animated"></span>
			<span class="skeleton_animated"></span>
			<span class="skeleton_animated"></span>
		</span>
	{{elseif type === "list"}}
		<span class="skeleton-list">
			{{#each content}}
				<span class="skeleton-list_content-wrapper">
					<span><span class="skeleton_animated"></span></span>
				</span>
			{{/each}}
		</span>
	{{else}}
		<span class="skeleton-base">
			<span class="skeleton_animated"></span>
		</span>
	{{/if}}
</span>
